import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "./rootReducer";

export interface RequirementNotesState {
  generatedNotes: string;
  loading: boolean;
  error: string | null;
}

const initialState: RequirementNotesState = {
  generatedNotes: "",
  loading: false,
  error: null,
};

const requirementNotesSlice = createSlice({
  name: "requirementNotes",
  initialState,
  reducers: {
    setGeneratedRequirementNotes: (state, action: PayloadAction<string>) => {
      state.generatedNotes = action.payload ?? "";
    },
    setRequirementNotesLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setRequirementNotesError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    resetRequirementNotesState: () => initialState,
  },
});

export const {
  setGeneratedRequirementNotes,
  setRequirementNotesLoading,
  setRequirementNotesError,
  resetRequirementNotesState,
} = requirementNotesSlice.actions;

export const selectRequirementNotesState = (state: RootState) =>
  state.requirementNotes;
export const selectGeneratedRequirementNotes = (state: RootState) =>
  state.requirementNotes.generatedNotes;
export const selectRequirementNotesLoading = (state: RootState) =>
  state.requirementNotes.loading;
export const selectRequirementNotesError = (state: RootState) =>
  state.requirementNotes.error;

export default requirementNotesSlice.reducer;
